// extracted by mini-css-extract-plugin
module.exports = {"root":"LimitedAccessBanner_root__2wFFd","text":"LimitedAccessBanner_text__yaKkY","button":"LimitedAccessBanner_button__10hu-"};